import { getValueFromLocalStorage, setValueToLocalStorage } from "helpers/mutable";
import { NAMESPACE_KEYS } from "constants/mutable";
import me from "models/me";

export const getAndIncrementRequestId = (collectionId: string) => {
    let requestId = parseInt(getValueFromLocalStorage(collectionId, me._id, NAMESPACE_KEYS.REQUEST, 0), 10);
    if (isNaN(requestId)) {
        requestId = 0;
    }
    requestId = requestId + 1;
    setValueToLocalStorage(collectionId, me._id, NAMESPACE_KEYS.REQUEST, requestId);
    return requestId.toString();
};
